// IconWithProgress.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { ActionIcon, Tooltip, Box } from '@mantine/core';
import { IconRobot } from '@tabler/icons-react';
import { keyframes } from '@emotion/react';

// Define spin animation for the border
const borderSpin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

// Define subtle pulse animation for the robot
const robotPulse = keyframes`
  0%, 100% { 
    opacity: 0.8;
    transform: scale(1);
  }
  50% { 
    opacity: 1;
    transform: scale(1.05);
  }
`;

// IconWithProgress Component
const IconWithProgress = ({ onClick, isLoading, tooltip, disabled }) => {
  const iconButton = (
    <ActionIcon
      onClick={onClick}
      color="blue"
      variant="subtle"
      aria-label={tooltip || 'Action'}
      disabled={isLoading || disabled}
      size="xl"
      style={{ position: 'relative' }}
    >
      {!isLoading ? (
        <IconRobot size={32} />
      ) : (
        <Box style={{ position: 'relative', display: 'inline-block' }}>
          {/* Robot icon with subtle pulse */}
          <IconRobot
            size={32}
            style={{
              color: 'inherit',
              animation: `${robotPulse} 2s ease-in-out infinite`
            }}
          />
          {/* Full circular border spinner */}
          <Box
            style={{
              position: 'absolute',
              top: '-4px',
              left: '-4px',
              width: '40px',
              height: '40px',
              border: '3px solid rgba(25, 118, 210, 0.2)',
              borderTop: '3px solid #1976d2',
              borderRadius: '50%',
              animation: `${borderSpin} 1s linear infinite`,
              pointerEvents: 'none'
            }}
          />
        </Box>
      )}
    </ActionIcon>
  );

  return tooltip ? (
    <Tooltip label={tooltip}>
      {iconButton}
    </Tooltip>
  ) : (
    iconButton
  );
};

// Define prop types
IconWithProgress.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool,
};

// Define default props
IconWithProgress.defaultProps = {
  isLoading: false,
  tooltip: '',
  disabled: false,
};

export default IconWithProgress;
